import { render } from "./CheckboxesComponent.vue?vue&type=template&id=67165a86"
import script from "./CheckboxesComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__